var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9CAE",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M0 10.83L10 0H9L0 9.75v1.08zm0-6.5L4 0H3L0 3.25v1.08zm0 13L16 0h-1L0 16.25v1.08zm0 6.5L22 0h-1L0 22.75v1.08zm30-19.5L10 26H9L30 3.25v1.08zm0 6.5L16 26h-1L30 9.75v1.08zm0 6.5L22 26h-1l9-9.75v1.08zm0 6.5L28 26h-1l3-3.25v1.08zM27 0h1L4 26H3L27 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.712c1c1086c180bcd499514e07f46646.svg";
export { ForwardRef as ReactComponent };